import React from "react";

// Full-width page header from the refresh banners. The photos keep their left
// third dark so the eyebrow and title sit there. Without an image the banner
// falls back to the navy panel, so pages still read correctly while a
// banner file is pending.
// `fade` is for photos without a dark left third: the photo sits in the right
// two-thirds and fades into the navy panel behind the title.
const PageBanner = ({ image, alt = "", eyebrow, title, fade = false }) => (
  <section className={`mrf-banner${image ? "" : " mrf-banner--plain"}${image && fade ? " mrf-banner--fade" : ""}`}>
    {image && <img className="mrf-banner__img" src={image} alt={alt} />}
    <div className="mrf-banner__inner">
      {eyebrow && <p className="mrf-banner__eyebrow">{eyebrow}</p>}
      {title && <h1 className="mrf-banner__title">{title}</h1>}
    </div>
  </section>
);

export default PageBanner;
